import { render } from "./MyAnalyzesView.vue?vue&type=template&id=51470cbd&scoped=true"
import script from "./MyAnalyzesView.vue?vue&type=script&lang=js"
export * from "./MyAnalyzesView.vue?vue&type=script&lang=js"

import "./MyAnalyzesView.vue?vue&type=style&index=0&id=51470cbd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51470cbd"]])

export default __exports__